// extracted by mini-css-extract-plugin
export default {"mainLayout":"style_mainLayout__MU1W+","content":"style_content__nqGfV","white":"style_white__Ju5OG","text":"style_text__wAmN-","buttons":"style_buttons__bsDN1"};